import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { db, auth, functions } from '../firebase';
import { collection, onSnapshot, query, doc, getDoc, setDoc, updateDoc, where, getDocs, documentId, orderBy, limit } from 'firebase/firestore';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { ipfsGateway, FIREBASE_PROJECT_ID, API_BASE_URL, BASE_MAX_STAMINA, TOKEN_CONTRACT, TOKENS, tokenContracts, tokenDecimals, buildingConfigClient, ATOMIC_API_ENDPOINTS, itemTemplates, EMBLEM_NAMES, MASTER_ACCOUNT_WAX_ID, ADMIN_ACCOUNTS, STAKING_TIERS, VAULT_TIERS, VAULT_TOKEN_INFO, VAULT_TOKEN_VALUE, getUpgradeCostClient, Client, calculateDiminishedBoost, calculateMaxHp, calculateXpForNextLevel } from '../constants/gameConfig';
import characterImage from '../assets/firecat.png';
import placeholderImage from '../assets/equip.png';
function LastSeasonalLeaderboardPage() {
  const [lastSeasonalLeaderboard, setLastSeasonalLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeasonalData = async () => {
      setLoading(true);
      try {
        const seasonsRef = collection(db, "seasons");
        // We order by endDate to ensure we look at when they finished
        const q = query(seasonsRef, orderBy("endDate", "desc"), limit(2));

        const querySnapshot = await getDocs(q);
        const docs = querySnapshot.docs;

        if (docs.length > 0) {
          const mostRecentSeason = docs[0].data();
          const now = new Date();
          const endDate = mostRecentSeason.endDate?.toDate();

          // LOGIC FIX:
          // If the newest season in the DB has ALREADY ended, show it (Index 0).
          // If the newest season is still running (future end date), show the previous one (Index 1).
          if (endDate && endDate < now) {
            setLastSeasonalLeaderboard(mostRecentSeason);
          } else {
            // Current season is active, so we want the one before it
            if (docs.length > 1) {
              setLastSeasonalLeaderboard(docs[1].data());
            } else {
              setLastSeasonalLeaderboard(null); // No previous season exists
            }
          }
        } else {
          setLastSeasonalLeaderboard(null);
        }
      } catch (error) {
        console.warn("Seasonal Leaderboard load skipped:", error.code);
        setLastSeasonalLeaderboard(null);
      } finally {
        setLoading(false);
      }
    };
    fetchSeasonalData();
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', margin: '20px auto', color: '#aaa' }}>Loading Season History...</div>;
  }

  if (!lastSeasonalLeaderboard || !lastSeasonalLeaderboard.leaderboard) {
    return (
      <div style={{ backgroundColor: 'rgba(0,0,0,0.7)', padding: '20px', borderRadius: '8px', maxWidth: '800px', margin: '20px auto', textAlign: 'center' }}>
        <h2>Season History</h2>
        <p style={{ color: '#aaa' }}>No completed seasons found.</p>
      </div>
    );
  }

  const seasonNum = lastSeasonalLeaderboard.seasonNumber || '?';
  const sDate = lastSeasonalLeaderboard.startDate?.toDate ? lastSeasonalLeaderboard.startDate.toDate().toLocaleDateString() : '';
  const eDate = lastSeasonalLeaderboard.endDate?.toDate ? lastSeasonalLeaderboard.endDate.toDate().toLocaleDateString() : '';

  return (
    <div style={{ backgroundColor: 'rgba(0,0,0,0.8)', padding: '20px', borderRadius: '8px', maxWidth: '800px', margin: '20px auto', border: '1px solid #444' }}>
      <h2 style={{ color: '#00e5ff', textAlign: 'center' }}>Season {seasonNum} Results</h2>
      <p style={{ textAlign: 'center', fontSize: '13px', color: '#aaa', marginBottom: '15px' }}>
        {sDate} — {eDate}
      </p>
      <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #555', color: '#888' }}>
            <th style={{ padding: '10px', textAlign: 'left' }}>Rank</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Wallet</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Score</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Prizes</th>
          </tr>
        </thead>
        <tbody>
          {lastSeasonalLeaderboard.leaderboard.map((player, index) => (
            <tr key={player.waxId} style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px' }}>{index + 1}</td>
              <td style={{ padding: '10px' }}>{player.waxId}</td>
              <td style={{ padding: '10px', textAlign: 'right', color: '#ff9800' }}>
                {Math.floor(player.seasonalPoints || 0).toLocaleString()}
              </td>
              <td style={{ padding: '10px', textAlign: 'right', color: '#4caf50' }}>
                {(player.tokensWon || []).join(', ') || '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default LastSeasonalLeaderboardPage;
